export default __webpack_public_path__ + "static/jedlickova-d5aa80d854b54f063fc6fdfe0f1cbd16.jpg";